import { useEffect, useState } from 'react';
import { ModalDialog } from './modalDialog.tsx';


interface Props {
    className?: string,
    style?: React.CSSProperties,
    imageData: Uint8Array | File | null | undefined;
    isViewMode: boolean;
    onImageChange?: (imageFile: File) => void;
}

export function VisualInspectionImage({
    className,
    style,
    imageData,
    isViewMode,
    onImageChange,
}: Props) {
    const [showingZoomedImage, setShowingZoomedImage] = useState(false);
    const [imageUrl, setImageUrl] = useState<string | null>(null);

    useEffect(() => {
        if (imageData) {
            const blob = imageData instanceof Blob
                ? imageData
                : new Blob([new Uint8Array(imageData)], { type: 'image/jpeg' });
            const objectUrl = URL.createObjectURL(blob);
            setImageUrl(objectUrl);

            return () => {
                URL.revokeObjectURL(objectUrl);
            };
        } else {
            setImageUrl(null);
            return undefined;
        }
    }, [imageData]);


    function handleImageChange(e: React.ChangeEvent<HTMLInputElement>) {
        if (e.target.files && e.target.files[0]) {
            const selectedImage = e.target.files[0];
            onImageChange?.(selectedImage);
        }
    }


    return (
        <div
            className={className}
            style={{
                ...style,
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            {!isViewMode &&
                <input
                    type='file'
                    accept='image/*'
                    onChange={handleImageChange}
                />
            }
            {imageUrl &&
                <img
                    style={{
                        flex: '1 1',
                        objectFit: 'contain',
                        minHeight: '0px',//Required to keep it from growing beyond the parent's bounds
                    }}
                    src={imageUrl}
                    onClick={() => setShowingZoomedImage(true)}
                    alt='Visual inspection image'
                />}
            {imageUrl &&
                <ModalDialog
                    isOpen={showingZoomedImage}
                    cancelOnOutsideClick={true}
                    onCancel={() => setShowingZoomedImage(false)}
                >
                    <img
                        style={{
                            maxWidth: '60vw',
                            maxHeight: '75vh',
                        }}
                        src={imageUrl}
                        alt='Visual inspection image'
                    />
                </ModalDialog>
            }
            {(!imageUrl && isViewMode) &&
                <div
                    style={{
                        flex: 1,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        textAlign: 'center',
                        padding: '20px',
                    }}
                >
                    No image available
                </div>
            }
        </div>
    );
}
